function formatCurrency(x) {
  var temp = parseFloat(x)
  temp = temp.toFixed(2)
  return `$${temp}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// This is used for react-table sorting method Expects currency value with leading $.
// If you need a decimal/number just use a different sort function or a default one
function sortCurrency(a, b, id) {
  const cur1 = parseFloat(a.original[id].substring(1).replace(',', ''))
  const cur2 = parseFloat(b.original[id].substring(1).replace(',', ''))
  return cur1 < cur2 ? 1 : -1
}
export { formatCurrency, sortCurrency }
